import KunLoading72 from './src/index'

KunLoading72.install = function (Vue) {
	Vue.component(KunLoading72.name, KunLoading72);
}

export default KunLoading72;
